import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import styles from './base-custom-size-option.module.scss';

interface BaseCustomSizeOptionProps {
  isSelected: boolean;
  customText: string;
  onClick: (e: React.MouseEvent) => void;
  sliderElement?: ReactElement | null;
}

export function BaseCustomSizeOption({isSelected, customText, onClick, sliderElement}: BaseCustomSizeOptionProps): ReactElement {
  return (
    <div
      onClick={onClick}
      className={`_full-width flex-v-row ${styles.customOption} ${isSelected ? styles.selected : ''} spacing-p-3 radius-4 _cursor-pointer hover-transition-all`}
    >
      <div className="flex-h-row _full-width justify-content-between">
        <Text bold={isSelected} size={TextSize.XSMALL} val={customText} />
        {isSelected ? <Icon icon="icon-check" size={IconSize.SIZE_ICON_20} /> : null}
      </div>
      {isSelected && sliderElement ? sliderElement : null}
    </div>
  );
}

